// extracted by mini-css-extract-plugin
module.exports = {"root":"icon-list-item_root__u60Ch","icon":"icon-list-item_icon__bTSmY","text":"icon-list-item_text__DFoJb"};